<script lang="ts">
  let type: "number" | "text" = "text";
  let value: number;
  let suffix = "";

  const className = `
    h-4
    w-16
    p-0
    text-center
    text-xxs
    font-bold
    bg-transparent
    border-x-0
    border-t-0
    border-b-[1px]
    border-solid
    border-slate-700
    outline-0
    focus:border-primary-500
    focus:[box-shadow:none]
    dark:border-zinc-300
    dark:focus:border-primary-500
  `;

  export {type, value, suffix};
</script>

<div class="relative">
  {#if type === "text"}
    <input class={className} type="text" bind:value on:input on:focusout/>
  {:else if type === "number"}
    <input class={className} type="number" bind:value on:input on:focusout/>
  {/if}
  {#if suffix}
    <div class="
      absolute
      top-[50%]
      right-0
      pointer-events-none
      text-xxs
      translate-y-[-50%]
    ">
      {suffix}
    </div>
  {/if}
</div>
